"use strict";
/**
 * Commands to manage settings related stuff
 */
Object.defineProperty(exports, "__esModule", { value: true });
var commands = require("../commands/commands");
var socketClient_1 = require("../../socket/socketClient");
commands.openSettingsFile.on(function () {
    socketClient_1.server.getSettingsFilePath({}).then(function (res) {
        commands.doOpenOrFocusFile.emit({ filePath: res.filePath });
    });
});



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/settings/settings.js
 ** module id = 451
 ** module chunks = 0
 **/